import { createAsyncThunk } from "@reduxjs/toolkit";
import { useHttp } from "../hooks/use-http";

const getAllTelejka = createAsyncThunk("telejka/getAll", async () => {
  const { request } = useHttp();
  return await request({
    url: "/bus_and_ser/cart_models/",
  });
});

export { getAllTelejka };
